export default __webpack_public_path__ + "images/d1c0298bfb7916421c39773be5b5baa9-conference.jpg";